import { defineMessages } from 'react-intl';
export var messages = defineMessages({
  inquiryCredits: {
    id: 'reservation.inquiry.credits',
    defaultMessage: '<strong>{credits}</strong> {credits, plural, one {Credit} other {Credits}}'
  },
  inquiryReserve: {
    id: 'reservation.inquiry.reserve',
    defaultMessage: 'Reserve this class'
  },
  topUpCreditsBalance: {
    id: 'reservation.top-up.credits.balance',
    defaultMessage: 'You have {credits, plural, one {# credit} other {# credits}}'
  },
  topUpCreditsBuy: {
    id: 'reservation.top-up.credits.buy',
    defaultMessage: 'Buy {credits, plural, one {# credit} other {# credits}}'
  },
  topUpCreditsCost: {
    id: 'reservation.top-up.credits.cost',
    defaultMessage: '{credits, plural, one {# credit} other {# credits}}'
  },
  topUpCreditsTax: {
    id: 'reservation.top-up.credits.tax',
    defaultMessage: ' + tax'
  },
  topUpHeader: {
    id: 'reservation.top-up.header',
    defaultMessage: 'Buy {credits, plural, one {# more credit} other {# more credits}} to reserve this class'
  },
  topUpReserve: {
    id: 'reservation.top-up.reserve',
    defaultMessage: 'Purchase and reserve'
  },
  confirmation: {
    id: 'reservation.confirmation',
    defaultMessage: 'Reservation Confirmed'
  },
  confirmationAddToCalendar: {
    id: 'reservation.confirmation.add-to-calendar',
    defaultMessage: 'Add to Google Calendar'
  },
  done: {
    id: 'reservation.done',
    defaultMessage: 'Done'
  },
  failed: {
    id: 'reservation.failed',
    defaultMessage: 'Reservation Failed'
  },
  inviteAFriendTextCopy: {
    id: 'reservation.invite-a-friend.text.copy',
    defaultMessage: 'Copy'
  },
  inviteAFriendTextCopied: {
    id: 'reservation.invite-a-friend.text.copied',
    defaultMessage: 'Copied!'
  },
  inviteAFriendTextOr: {
    id: 'reservation.invite-a-friend.text.or',
    defaultMessage: 'or'
  },
  inviteAFriendSchedule: {
    id: 'reservation.invite-a-friend.schedule',
    defaultMessage: 'You‘re booked for <strong>{startTime, date, short} at {startTime, time, short}</strong>'
  },
  inviteAFriendEmailInvite: {
    id: 'reservation.invite-a-friend.email.invite',
    defaultMessage: 'Email invite'
  },
  inviteAFriendEmailSubject: {
    id: 'reservation.invite-a-friend.email.subject',
    defaultMessage: 'Want to work out with me?'
  },
  inviteAFriendUnavailableTitle: {
    id: 'reservation.invite-a-friend.unavailable.title',
    defaultMessage: 'That class filled up fast!'
  },
  inviteAFriendUnavailableSubtitle: {
    id: 'reservation.invite-a-friend.unavailable.subtitle',
    defaultMessage: 'This class is no longer available for bringing a friend. Next time you book a class, try again!'
  },
  inviteAFriendUnavailableCta: {
    id: 'reservation.invite-a-friend.unavailable.cta',
    defaultMessage: 'Okay'
  }
});